/*************************************************************************************
	C O M M O N - S E R V I C E S
**************************************************************************************/
import { isEmpty } from "lodash";
import React from "react";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { CONFIG } from "../config/configs";
import CryptoJS from "crypto-js";

const commonService = {
	/*************************************************************************************
	@purpose	:	Store Data To local Storage
	**************************************************************************************/
	setItem(key, value) {
		localStorage.setItem(key, value);
	},

	/*************************************************************************************
	@purpose	:	Get Data From local Storage
	**************************************************************************************/
	getItem(key) {
		return localStorage.getItem(key);
	},

	/*************************************************************************************
	@purpose	:	Remove Data in local Storage
	**************************************************************************************/
	removeItem(key) {
		localStorage.removeItem(key);
	},

	/*************************************************************************************
	@purpose	:	Email Validation
	**************************************************************************************/
	validateEmail(email) {
		const pattern = new RegExp(
			/^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
		return pattern.test(email);
	},

	/*************************************************************************************
	@purpose	:	Password Validation
	**************************************************************************************/
	validatePassword(pass) {
		const pattern = new RegExp(
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,20}$/
		);
		return pattern.test(pass);
	},

	/*************************************************************************************
	@purpose	:	Password Validation
	**************************************************************************************/
	validateConfirmPassword(pass, confirmpass) {
		if (pass === confirmpass) {
			return true;
		} else {
			return false;
		}
	},

	/*************************************************************************************
	@purpose	:	First and Last Name Validation
	**************************************************************************************/
	validateMobileNumber(format, mobileNumber) {
		return (
			(format.match(/\./g) || []).length === mobileNumber.match(/\d/g).length
		);
	},

	/*************************************************************************************
	@purpose	:	Character Validation
	**************************************************************************************/
	allowChar(e) {
		const pattern = new RegExp(/^[a-zA-Z\s]{0,255}$/);
		return pattern.test(e);
	},

	/*************************************************************************************
	@purpose	:	Number Validation
	**************************************************************************************/
	allowNumbers(e) {
		const pattern = new RegExp(/^[0-9\b]+$/);
		return pattern.test(e);
	},

	/*************************************************************************************
	@purpose	:	Set Success Message
	**************************************************************************************/
	showSuccessMessage(msg) {
		swal({
			position: "center",
			icon: "success",
			text: msg,
			buttons: false,
			timer: 2500,
			className: "custom-toaster",
		});
	},

	/*************************************************************************************
	@purpose	:	Set Error Message
	**************************************************************************************/
	showErrorMessage(msg) {
		swal({
			position: "center",
			icon: "error",
			text: typeof msg === "string" ? msg : "Internal Server Error",
			className: "custom-toaster",
			buttons: {
				cancel: "Close",
			},
		});
	},

	/*************************************************************************************
	@purpose	:	Set Warning Message
	**************************************************************************************/
	showWarningMessage(msg) {
		swal({
			position: "center",
			icon: "warning",
			text: msg,
			buttons: false,
			timer: 3000,
			className: "custom-toaster",
		});
	},

	/*************************************************************************************
	@purpose	:	Get full image url
	**************************************************************************************/
	renderImageUrl(path, type = "admin", append) {
		let src = "/assets/images/default-user.png";
		if (append) {
			if (!isEmpty(path)) {
				src = path;
			}
		} else {
			if (!isEmpty(path)) {
				src = path;
				// if (type === "other") {
				// 	src = CONFIG.IMG_GET_URL + getFileName(path);
				// } else {
				// 	// src = CONFIG.IMG_GET_URL + path;
				// 	src = path;
				// }
			}
		}

		return (
			<img
				className="round"
				src={src}
				alt="avatar"
				height="40"
				width="40"
				onError={(e) => {
					e.target.onerror = null;
					e.target.src = "/assets/images/default-user.png";
				}}
			/>
		);
	},

	filterData(filterObj, newObj) {
		let newObject = {};
		for (const property in filterObj) {
			if (property != [newObj.alias]) {
				newObject[property] = filterObj[property];
			}
		}
		return newObject;
	},
	guestUserAlert(phoneNumber, email) {
		Swal.fire(
			"Guest User",
			phoneNumber
				? `Please onboard user with this phone number: ${phoneNumber}`
				: `Please onboard user with this email: ${email}`
		);
	},

	/*************************************DATE AND TIME*******************************/
	/**
	 * @returns timezone
	 */
	getTimezone() {
		return Intl.DateTimeFormat().resolvedOptions().timeZone;
	},
	/**
	 *
	 * @param {*} date
	 * @param {*} hours hours to set defaut is 0
	 * @param {*} min minutes to set defaut is 0
	 * @param {*} sec seconds to set defaut is 0
	 * @returns UTC date with time
	 */
	convertDateToUTC(date, hours = 0, min = 0, sec = 0) {
		return new Date(new Date(date).setHours(hours, min, sec)).toISOString();
	},

	encryptData(data) {
		if (!data) return "";
		const ciphertext = CryptoJS.AES.encrypt(
			data,
			CONFIG.PRIVATE_KEY
		).toString();
		return ciphertext;
	},

	decryptData(data) {
		if (!data) return "";
		const bytes = CryptoJS.AES.decrypt(data, CONFIG.PRIVATE_KEY);
		const originalText = bytes.toString(CryptoJS.enc.Utf8);
		return originalText;
	},
	//	End
};

export default commonService;
